module.exports = __webpack_public_path__ + "img/p15074.f1e87e7b.jpg";